import { Constructor, DoorType } from "../@types/shared";
import { DoubleSwingDoors, SingleSwingDoors } from "../constants";
import { TransomHardwareCreationStrategies } from "../domain/strategies";
import { ICreateManyStrategy } from "../domain/strategies/base/creation.strategy";

export class TransomHardwareStrategyRegistry {
    private strategies = new Map<string, Constructor<ICreateManyStrategy>>();

    // prettier-ignore
    constructor() {
        this.register(SingleSwingDoors as DoorType[], TransomHardwareCreationStrategies.SingleSwingDoorHardwareStrategy);
        this.register(DoubleSwingDoors as DoorType[], TransomHardwareCreationStrategies.DoubleSwingDoorHardwareStrategy);
    }

    getStrategy = (
        doorCode: DoorType,
    ): Constructor<ICreateManyStrategy> | null => {
        return this.strategies.get(doorCode) || null;
    };

    private register = (
        doorTypes: DoorType[],
        strategy: Constructor<ICreateManyStrategy>,
    ) => {
        for (const doorType of doorTypes) {
            this.strategies.set(doorType, strategy);
        }
    };
}
